import { render, staticRenderFns } from "./object-fit.vue?vue&type=template&id=0e3f4e2f&"
import script from "./object-fit.vue?vue&type=script&lang=js&"
export * from "./object-fit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src271809469/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e3f4e2f')) {
      api.createRecord('0e3f4e2f', component.options)
    } else {
      api.reload('0e3f4e2f', component.options)
    }
    module.hot.accept("./object-fit.vue?vue&type=template&id=0e3f4e2f&", function () {
      api.rerender('0e3f4e2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/object-fit/object-fit.vue"
export default component.exports